/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import WrapperScroll from '@app/components/WrapperScroll/WrapperScroll';
import { useState } from 'react';
import styles from '@app/components/BannerSlider/styles.module.scss';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
const BlogCatList = /*#__PURE__*/styled("div")({
  name: "BlogCatList",
  class: "b1jouv0s"
});
export const BlogCate = ({
  cats,
  handleClickBlogCate
}) => {
  const [active, setActive] = useState(1210);
  const handleClick = cat => {
    setActive(cat.id);
    handleClickBlogCate(cat);
  };
  return <BlogCatList className="blogCate">
      <WrapperScroll hideIcon total={cats.length} cols={cats.length} mobile={{
      cols: 2.6
    }} className={styles.oneRowContent} noPadding>
        <div className="row-cat">
          {cats.map(cat => {
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div key={cat.id} onClick={() => handleClick(cat)} className={`row-cat-item ${active === cat.id ? 'active' : ''}`}>
                <span>{cat.name}</span>
              </div>
          );
        })}
        </div>
      </WrapperScroll>
    </BlogCatList>;
};

require("../../../../.linaria-cache/src/components/GridAdsProject/BlogCate/BlogCate.linaria.module.css");